<template>
  <div class="forget_password">
    <p><i @click="goBack('login')">&#10005</i></p>
    <div class="forget_password_content" v-if="showStep === 1">
      <p>请输入您要找回的{{numName}}账号:</p>
      <input type="text" title="账号" v-model.trim="forgetNum">
      <p class="warn" v-if="errorTxt">{{errorTxt}}</p>
      <!--<p>您输入的登录账号不存在或错误，请重新进行进行输入。</p>-->
      <!--<p>找回密码只支持超级管理员账号找回，您可联系超级管理员账号登录系统对您账号进行密码重置。</p>-->
    </div>
    <div class="forget_password_content" v-if="showStep === 2">
      <!--{{forgetTel.substring(0,3)}}****{{forgetTel.substring(8,11)}}-->
      <p>验证码已发送到号码为{{keepOutTel}}的手机上，请输入收到的手机验证码：</p>
      <input class="clear" type="text" title="账号" v-model.trim="verificationCode" style="width: 60%; float: left">
      <a v-if="sendCodeStep === 1" class="send_code" @click="sendCode(2)">再发送一次</a>
      <a v-if="sendCodeStep === 2" class="send_code noDrop">验证码已发送，{{countDown}}秒后可重新发送</a>
      <p class="warn" style="margin-top: 20px" v-if="errorTxt">{{errorTxt}}</p>
      <!--<p class="warn">您输入的验证码有误，请重新输入</p>-->
    </div>
    <div class="forget_password_content"  v-if="showStep === 3">
      <div>
        <label>新密码：</label>
        <input type="password" title="新密码" v-model.trim="newPwd">
      </div>
      <div>
        <label>确认密码：</label>
        <input type="password" title="新密码" v-model.trim="newConfirmPwd">
      </div>
      <p class="warn" style="padding: 0 80px" v-if="errorTxt">{{errorTxt}}</p>
    </div>
    <div class="forget_password_bottom">
      <button v-if="showStep !== 3" @click="nextStep(showStep + 1)">下一步</button>
      <button v-if="showStep === 3" @click="confirmBtn()">确定</button>
    </div>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
  </div>
</template>

<script type="es6">
  import LoadingDialog from '../public-component/loading-dialog';

export default {
  name: 'forget-password',
  props: ['numType'],
  comments: {LoadingDialog},
  data() {
    return {
      spUrl: '', // 供应商登录地址
      numName: '', // 账号类型名称： proxy=分销商    supplier=供应商
      cType: '', // 账号类型：分销商为px,供应商为sp
      forgetNum: '', // 忘记密码的账户
      forgetTel: '', // 手机号
      keepOutTel: '', // 遮挡的手机号
      errorTxt: '', // 错误提示
      verificationCode: '', // 验证码
      sendCodeStep: 1, // 发送验证码步骤： 1=再发送一次  2=验证码已发送
      countDown: '', // 倒计时
      newPwd: '', // 新密码
      newConfirmPwd: '', // 确认密码
      showStep: 1, // 显示的步骤： 1=填入账号   2=发送验证码   3=输入重新验证码
      isLoading: false // 是否显示加载框
    }
  },
  methods: {
    // 下一步
    nextStep (step) {
      if (this.showStep === 1) {
        if (!this.forgetNum) {
          this.errorTxt = '请输入账号';
        } else {
          // this.errorTxt = '';
          // this.showStep = step;
          this.checkAgentOrSupplyAccount(step);
        }
      } else if (this.showStep === 2) {
        if (!this.verificationCode) {
          this.errorTxt = '请输入验证码';
        } else {
          // this.errorTxt = '';
          // this.showStep = step;
          this.checkFindSmsCode(step);
        }
      }
    },

    // 忘记密码——检验输入的分销商或供应商的账户 是否符合
    checkAgentOrSupplyAccount(step) {
      this.$axios.get(this.Global.checkAgentOrSupplyAccount(this.cType, this.forgetNum)).then((res) => {
        console.log(res);
        if (!res.data.errorMsg.length) {
          this.errorTxt = '';
          this.showStep = step;
          this.forgetTel = res.data.resData;
          this.keepOutTel = this.forgetTel.substring(0, 3) + '****' + this.forgetTel.substring(8, 11);
          console.log(this.keepOutTel);
        } else {
          this.errorTxt = res.data.errorMsg;
        }
      });
    },

    // 检验验证码
    checkFindSmsCode(step) {
      this.$axios.get(this.Global.checkFindSmsCode(this.cType, this.forgetNum, this.forgetTel, this.verificationCode)).then((res) => {
        if (!res.data.errorMsg.length) {
          this.errorTxt = '';
          this.showStep = step;
        } else {
          this.errorTxt = res.data.errorMsg;
        }
      });
    },

    // 再次发送找回密码的验证码
    sendFindPwdSmsCode(step) {
      this.$axios.get(this.Global.sendFindPwdSmsCode(this.cType, this.forgetNum, this.forgetTel)).then((res) => {
        console.log(res);
        if (!res.data.errorMsg.length) {
          this.errorTxt = '';
          // this.showStep = step;
          this.sendCodeStep = step;
          this.countDown = 30;
          const self = this;
          let timer; // 计时器
          timer = setInterval(function () {
            self.countDown = --self.countDown;
            if (self.countDown < 1) {
              self.sendCodeStep = 1;
              clearInterval(timer);
            }
          }, 1000);
        } else {
          this.errorTxt = res.data.errorMsg;
        }
      });
    },

    // 发送验证码
    sendCode (step) {
      this.sendFindPwdSmsCode(step);
      // this.sendCodeStep = step;
      // this.countDown = 30;
      // const self = this;
      // let timer; // 计时器
      // timer = setInterval(function () {
      //     self.countDown = --self.countDown;
      //     if (self.countDown < 1) {
      //       self.sendCodeStep = 1;
      //       clearInterval(timer);
      //     }
      // }, 1000);
    },

    // 修改供应商或分销商的密码
    findPwdChange() {
      this.isLoading = true;
      const params = {
        ctype: this.cType,
        loginName: this.forgetNum,
        newpwd: this.newPwd
      };
      this.$axios.post(this.Global.findPwdChange, params).then((res) => {
        this.isLoading = false;
        if (res) {
          if (!res.data.errorMsg.length) {
            this.errorTxt = '';
            // this.showStep = step;
            this.goBack('alertSuc');
          } else {
            this.errorTxt = res.data.errorMsg;
          }
        } else {
          this.isLoading = false;
        }
      });
    },

    // 确认按钮
    confirmBtn() {
      if (!this.newPwd) {
        this.errorTxt = '请输入新密码';
      } else if (!this.newConfirmPwd) {
        this.errorTxt = '请输入确认密码';
      } else if (this.newPwd !== this.newConfirmPwd) {
        this.errorTxt = '两次密码输入不一致，请重新输入';
      } else {
        // this.goBack('alertSuc');
        this.findPwdChange();
      }
    },

    // 返回登录页
    goBack (showType) {
      let path = '/login';
      if (showType === 'supplier') {
        path = this.spUrl + '/login';
      }
      this.$router.push({
        // path: '/login'
        path: path
      });
      this.$emit('goBack', {showType: showType});
    }
  },
  created() {
    /* 获取供应商部署地址 */
    this.$axios.get(this.Global.getSPUrl).then((res) => {
      this.spUrl = res.data.resData;
    });
    if (this.numType === 'proxy') {
      this.numName = '分销商';
      this.cType = 'px';
    } else {
      this.numName = '供应商';
      this.cType = 'sp';
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/style";
.forget_password {
  width: 523px;
  margin-bottom: 60px;
  background-color: #fff;
  border-radius: 10px 10px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);

  p {
    &.warn {
      color: #ff0000;
      margin-top: 10px;
    }
  }

  &>p {
    text-align: right;
    padding-top: 10px;
    margin: 10px;
    font-weight: 800;

    i {
      font-style: normal;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .forget_password_content {
    padding: 30px 35px;

    p {
      margin-bottom: 20px;
    }

    input {
      height: 30px;
      border-radius: 0;
      box-shadow: 0 0 2px rgba(0, 0, 0, 0.35);
    }

    .send_code {
      width: 140px;
      margin-left: 5px;
      display: inline-block;
      color: rgba(22, 155, 213, 0.8);

      &:hover {
        cursor: pointer;
      }

      &.noDrop {
        &:hover {
          cursor: no-drop;
        }
      }
    }

    &>div {
      margin-bottom: 20px;

      label {
        display: inline-block;
        width: 80px;
        text-align: right;
      }

      input {
        width: 65%;
      }
    }
  }

  .forget_password_bottom {
    background-color: #ffffff;
    padding: 30px 0;
    text-align: right;
    border-radius: 0 0 10px 10px;

    button {
      width: 100px;
      height: 35px;
      line-height: 35px;
      border: none;
      background-color: $loginColor;
      font-size: 14px;
      color: #ffffff;
      margin-right: 55px;

      &:hover {
        cursor: pointer;
        background-color: rgba(22, 155, 213, 0.8);
      }

      &.forbid {
        background-color: rgba(22, 155, 213, 0.8);

        &:hover {
          cursor: no-drop;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/forget-password/forget-password.vue